export const style = {
  description: {
    fontWeight: 400,
    textAlign: 'center',
  },
  span: {
    marginRight: '4px',
    '& svg': {
      fontSize: '17px',
      lineHeight: '33px',
    },
  },
  Box: {
    sx: {
      color: 'primary.text',
      fontWeight: 500,
      display: 'flex',
    },
  },
  Typography: {
    sx: {
      display: 'flex',
      alignItems: 'center',
      color: 'primary.text',
      fontWeight: 500,
      width: '140px',
    },
  },
} as const;
